import { render, staticRenderFns } from "./FiltroPedido.vue?vue&type=template&id=45830c1a&scoped=true"
import script from "./FiltroPedido.vue?vue&type=script&lang=js"
export * from "./FiltroPedido.vue?vue&type=script&lang=js"
import style0 from "./FiltroPedido.vue?vue&type=style&index=0&id=45830c1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45830c1a",
  null
  
)

export default component.exports